/* eslint-disable camelcase */
// /* menu.js - customizable menus for register (sale, layaway, special order, edit workorder), Admin->Advanced Setup->Custom Menus for setup */

class Menu implements MerchantosMenu {
  /**
   * Opens an inline menu below the root menu
   *
   * @param {string} rootMenu the type of the root menu we are under (sale, refund, layaway, special_order, workorder)
   * @param {string} id of the submenu to get
   * @return true
   */
  getSubmenu = (
    rootMenu: 'sale' | 'refund' | 'layaway' | 'special_order' | 'workorder',
    id: string
  ) => {
    const content_map = {} as ContentMap;
    content_map.form_name = 'menu.get_submenu';
    content_map.root_menu_type = rootMenu;
    content_map.menu_id = id;

    window.doServerCall(content_map, (result) => window.merchantos.menu.ajaxMenu_Return(result));
    return true;
  };

  /**
   * Close the open submenu, if there is one
   *
   * @return true
   */
  closeSubmenu = () => {
    $('#add_expander_menu_holder').hide();
    $('#add_expander_menu_holder .category').empty();
  };

  /**
   * Opens an inline menu below the root menu
   *
   * @param rootMenu the type of the root menu we are under (sale, refund, layaway, special_order, workorder)
   * @param categoryId category_id to get to base the submenu off of, can be = 0 to get root categories
   * @return true
   */
  getCategorySubmenu = (
    rootMenu: 'sale' | 'refund' | 'layaway' | 'special_order' | 'workorder',
    categoryId: string,
    page?: number
  ) => {
    const content_map = {} as ContentMap;
    content_map.form_name = 'menu.get_category_submenu';
    content_map.root_menu_type = rootMenu;
    content_map.category_id = categoryId;
    if (page) {
      content_map.page = page;
    }

    window.doServerCall(content_map, (result) => window.merchantos.menu.ajaxMenu_Return(result));
    return true;
  };

  /**
   * Function called after ajax response is received
   *
   * @param array result the array of result fields
   */
  ajaxMenu_Return = (result: AjaxFormsResponse) => {
    if (window.merchantos.edit_workorder.isWithinView()) {
      // if we are on a view and there are hidden register version of workorders then remove them
      // their id's might conflict with ours and create weird behaviour (like innerHTMLs getting filled in on hidden workorder)
      // instead of the view
      // $('#non_ajax_content').html('');
    } else {
      // same as above but remove view edit workorder html if we are on the register
      $('#view_edit_workorder').html('');
    }

    if (result.close_submenu) {
      this.closeSubmenu();
    }

    if (result.submenu) {
      $('#add_expander_menu_holder').show().htmlReplace(result.submenu);
    }

    if (result.set_focus) {
      window.merchantos.focus.set(result.set_focus);
    }
  };
}

window.merchantos.menu = new Menu();
